'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-flex;\n  flex-direction: column;\n  padding: 5px 0;\n'], ['\n  display: inline-flex;\n  flex-direction: column;\n  padding: 5px 0;\n']);

var _Card = require('../Card');

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Menu = _Card2.default.extend(_templateObject);

Menu.displayName = 'Menu';

exports.default = Menu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/Menu/Menu.js
// module id = 553
// module chunks = 4